import classNames from "classnames";
import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { useIdCopy } from "@hooks/useIdCopy";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { HStack } from "@design-system/HStack/HStack";
import { DocumentCategoryIcon } from "@components/documents/DocumentCategoryIcon";
import { DocumentCategoryRow } from "../utils";
import styles from "../DocumentCategories.module.scss";

export const NameCell = memo(function NameCell({
    row,
}: CellContext<ViewTableFeatures, DocumentCategoryRow, unknown>) {
    const item = row.original;

    const { getCopyProps } = useIdCopy({
        label: item.parentId ? "Subtype" : "Type",
    });

    return (
        <ViewTableCell>
            <HStack
                align="center"
                className={classNames(
                    styles.categoryIdCell,
                    item.parentId && styles.categoryIdCellSubCategory,
                )}
            >
                {item.parentId ? (
                    <div
                        className={classNames(styles.rowIcon, styles.childIcon)}
                    >
                        <div className={styles.verticalLine} />
                    </div>
                ) : (
                    <DocumentCategoryIcon
                        documentTaxonomy={item.documentTaxonomy}
                    />
                )}

                <span
                    className={classNames(styles.categoryLabel, {
                        [styles.categoryLabelCollapsible]: !item.parentId,
                    })}
                    {...getCopyProps(item.id)}
                >
                    {item.label}
                </span>
            </HStack>
        </ViewTableCell>
    );
});
